import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "repeat",
  "use": "repeat-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"repeat\"><path d=\"M512 192H320l71.765-71.765C355.5 83.972 307.285 64 256 64s-99.5 19.972-135.765 56.235C83.972 156.5 64 204.715 64 256s19.972 99.5 56.235 135.765C156.5 428.028 204.715 448 256 448s99.5-19.972 135.764-56.236a195.885 195.885 0 0 0 8.728-9.334l48.16 42.141C401.729 478.154 332.82 512 256 512 114.615 512 0 397.385 0 256S114.615 0 256 0c70.693 0 134.684 28.663 181.008 74.992L512 0v192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/repeat.svg
// module id = nqcK
// module chunks = 1